import React, { useEffect, useState, FC } from "react";
import { Button, Form, message, Modal, Tooltip, Upload } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel from "@/model/navModel";
import { usePurchasePlanDetailsModel } from "./purchasePlanDetailsModel";
import { globalPrompt } from "@/components/message";
import { ITopType } from "@/types/ScmTypes";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import useGlobalModel, { transOptions, getFindItem } from "@/model/globalModel";
import { DetailType } from "@/types/ScmEnums";
import { usePurchasePlanModel } from "../../purchasePlanModel";
import { debounce } from "lodash";
import FontIcon from "@/components/YhIcon";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { YhAuth } from "@/components/auth/YhAuth";
import { UploadOutlined } from "@ant-design/icons";
import { UploadChangeParam, UploadFile } from "antd/lib/upload/interface";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { fileDownload } from "@/utils/exportFile";
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";
import { warehouseService } from "@/views/base/warehouse/warehouseService";
export const FormBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const {
        detailEditForm,
        detailAddForm,
        detailLookForm,
        detailAddList,
        detailDataSource,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        insertDetail,
        editDetail,
        setDetailAddForm,
        setDetailAddList,
        setDetailDataSource,
        setTopButsControl,
        setSupplierHistoryModel,
        setSupplierHistoryVisible,
        formComputeRule,
        supMore, setSupMore,
        more, setMore,
        saveLoading, setSaveLoading,
        Transfer, topButsControl, initForm,
        warehouseData, setWarehouseData, transferwarehouseList
    } = usePurchasePlanDetailsModel();
    const {
        setSelectedRowKeys,
        setSelectedRow,
        setDescRows,
    } = usePurchasePlanModel()
    const { getTreeNodeName } = useDictModel();
    const { beShopDs, supplieAllList, CustomerData, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs } = useGlobalModel();


    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { getSelectedDictOne } = useDictModel();
    const { user: { roles } } = useGlobalModel();
    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        if (mode === DetailType.add) {
            const params = {
                pageSize: 10000,
                pageNum: 1,
                shopId: shopId,
            }
            warehouseService.page(params).then(res => {
                const { retData } = res;
                setWarehouseData({ ...warehouseData, add: retData.records })
            })
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("11-1-1") && resetAddCatch(mode);
            !findNav("11-1-2") && resetEditCatch(mode);
        }
    }, [selectedNavId])
    const goodsList = mode === "add" ? detailAddList : detailDataSource
    const goSupplier = () => {
        replaceNav(
            selectedNavId,
            "13-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const save = () => {
        if (!formComputeRule(mode)) return;
        let goods = mode === "add" ? detailAddList : detailDataSource
        let purcharseNum = goods.filter(item => item.planNum == 0)
        if (purcharseNum.length > 0) {
            globalPrompt("message", { text: `【${purcharseNum.map(item => item.materialName).join()}】的采购数量不能为0`, type: "error" })
            return
        }
        IFormRef.current?.validateFields().then(async res => {
            const { fileList = [], ...val } = res
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    console.log(file)
                    return message.error('文件信息有误，请重新上传文件')
                }
                val.md5 = file?.uid
                val.fileName = file?.name
            }
            // else {
            //     val.md5 = ''
            //     val.fileName = ''
            // }
            if (mode === "add") {
                const resData = await insertDetail(val)
                if (resData) {
                    globalPrompt("message", { text: "新增成功", type: "success" });
                    resetAddCatch(mode);
                    goBack();
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                }
            } else if (mode === "edit") {
                let { id, planCode } = detailEditForm
                const resData = await editDetail({ ...val, id, planCode })
                if (resData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    getDetailEditOne(planCode as string, mode)
                }
            }
        })
    }
    const goBack = () => {
        replaceNav(selectedNavId, "11-1")
    }
    const onRefresh = async () => {
        if (mode === 'add') {
            IFormRef.current?.resetFields()
            setDetailAddForm(initForm)
            setDetailAddList([])

        } else if (mode === 'edit') {
            getDetailEditOne(id, mode)
        }
        message.success("刷新成功")
    }

    const onTrunPo = async () => {
        let materialNames: string[] = []
        await detailDataSource.forEach(item => {
            if (item.num === 0) {
                materialNames.push(item.materialName as string)
            }
        })
        if (materialNames.length !== detailDataSource.length) {
            let ret = await Transfer()
            if (ret) {
                resetEditCatch(mode);
                goBack();
                globalPrompt("message", { "text": "转接成功", "type": "success" });
            } else {
                globalPrompt("message", { "text": "转接失败", "type": "error" })
            }
        } else {
            await globalPrompt("message", { type: "error", text: `请输入${materialNames.toString()}的到货数量` })
        }

    }
    const rightChildren = <>
        {
            mode === "edit" && <>
                <YhAuth resCode={ResourceAuthEnum.P_PL_ED_TRANS}>
                    <Button
                        className="mr-5"
                        type="primary"
                        shape="round"
                        disabled={topButsControl}
                        onClick={debounce(() => { onTrunPo() }, 900)}
                    >转采购单</Button>
                </YhAuth>
            </>
        }
        {mode !== "look" &&
            <YhAuth resCode={ResourceAuthEnum.P_PL_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { save() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>
        }
        {mode !== "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onRefresh}
        >刷新</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>;
    //采购实体
    const benttityChange = (value: string, option: ISelectOption) => {
        option && onChange({ bentityName: option.label, bentityCode: option.value });
    }
    // const supplierTypeChange = (value: string, option: ISelectOption) => {
    //     option && onChange({ supplierTypeName: option.label, supplierTypeCode: option.value });
    // }
    const materialTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ materialTypeName: option.label, materialTypeCode: option.value });
    }
    const purchaseTypeChange = async (value: string, option: ISelectOption) => {
        // let goods = mode === "edit" ? detailDataSource : detailAddList;
        // if (goods.length > 0) {
        //     let newData = await transferwarehouseList(goods, value, mode)
        //     mode === "edit" ? setDetailDataSource([...newData]) : setDetailAddList([...newData])
        // }
        option && onChange({ purchaseTypeName: option.label, purchaseTypeCode: option.value });
    }
    const deliveryChange = (value: string, option: ISelectOption) => {
        option && onChange({ deliveryMethodName: option.label, deliveryMethod: option.value });
    }
    //结算方式
    const payMethodChange = (value: string, option: ISelectOption) => {
        option && onChange({ deliveryMethodName: option.label, deliveryMethod: option.value });
    }
    const payTypeChange = (value: string, option: ISelectOption) => {
        // console.log(option, getSelectedDictOne(DictCodeEnmu.PAY_METHOD),)
    }
    const typeForm = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    const onConsumption = () => {
        let { supplierCode, supplierName } = typeForm[mode]
        if (!supplierCode) {
            return message.warning("请先选择供应商")
        }
        setSupplierHistoryVisible(true)
        setSupplierHistoryModel({ supplierName: supplierName as string })
    }
    //所属站点
    const shopNameChange = async (value: string, option: ISelectOption) => {
        const params = {
            pageSize: 10000,
            pageNum: 1,
            shopId: option.value,
        }
        let { retData } = await warehouseService.page(params);
        const { records, ...pg } = retData;
        setWarehouseData({ ...warehouseData, add: records })
        setDetailAddList([])
        option && onChange({ shopId: option.value, shopCode: option.code, shopName: option.label });
    }

    const title = <>
        <span>基础信息</span>
        <Tooltip placement="topLeft" title="采购历史">
            <FontIcon type="icon-xiaofeijilu" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onConsumption}
            />
        </Tooltip>

        {!roles.includes('hd-supplier') ? <a className="color-blue" style={{ float: 'right', fontSize: '17px' }} onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a> :
            <a className="color-blue" style={{ float: 'right', fontSize: '17px' }} onClick={() => setSupMore(!supMore)}>{more ? '更多>>' : "隐藏"}</a>}
    </>
    const normFile = (e: UploadChangeParam) => {
        // let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
        // let isType: boolean = false
        // let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf('.'))
        // isType = filetypes?.includes(fileEnd) ?? false
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
                // e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        // if (!isType) {
        //     e.fileList?.pop()
        // }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    const baseFormItem: any = {
        title: title,
        // rightChildren,
        // style: { padding: "18px 0 0 0", marginBottom: "15px" },
        // contentClass: "pr-77",
        items: [

            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "采购计划号",
            //     fieldName: "planCode",
            //     disable: true,
            //     placeholder: "自动生成"
            // },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={goSupplier}>供应商名称</span>,
                fieldName: "supplierCode",
                allowClear: true,
                showSearch: true,
                hidden: roles.includes('hd-supplier') && supMore,
                disable: mode !== 'add',
                options: transOptions(supplieAllList),
                rules: [{ required: true, message: "请选择供应商" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                hidden: roles.includes('hd-supplier') && supMore,
                rules: [{ required: true, message: "请输入联系人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                hidden: roles.includes('hd-supplier') && supMore,
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "采购类型",
                fieldName: "purchaseTypeCode",
                allowClear: true,
                showSearch: true,
                hidden: roles.includes('hd-supplier') && supMore,
                disable: goodsList.length > 0 ? true : false,
                options: getSelectedDictOne(DictCodeEnmu.PURCHASE_TEPE),
                onSelectChange: purchaseTypeChange,
                rules: [{ required: true, message: "请选择采购类型" }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "结算类型",
                hidden: roles.includes('hd-supplier') && supMore,
                fieldName: "payType",
                allowClear: true,
                showSearch: true,
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE),
                onSelectChange: payTypeChange,
                rules: [{ required: true, message: "请输入结算类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "所属站点",
                fieldName: "shopId",
                hidden: roles.includes('hd-supplier') && supMore,
                options: allShopDs,
                showSearch: false,
                onSelectChange: shopNameChange,
                rules: [{ required: true, message: "请选择所属站点" }],
                disable: shopType === 0 && mode == 'add' ? false : true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "shopName",
                fieldName: "shopName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商类型",
                fieldName: "supplierTypeName",
                disable: true,
                hidden: roles.includes('hd-supplier'),
                // treeData: getTreeSelectOne(DictCodeEnmu.SUPPLIER_TYPE),
                // onSelectChange: supplierTypeChange,
                // rules: [{ required: true, message: "请选择供应商类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "商品类型",
                fieldName: "materialTypeCode",
                allowClear: true,
                showSearch: true,
                hidden: roles.includes('hd-supplier'),
                options: getSelectedDictOne(DictCodeEnmu.MATERIAL_TYPE),
                onSelectChange: materialTypeChange,
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "运输方式",
                fieldName: "deliveryMethod",
                allowClear: true,
                showSearch: true,
                hidden: roles.includes('hd-supplier'),
                options: getSelectedDictOne(DictCodeEnmu.LOGISTIC_MODE),
                onSelectChange: deliveryChange,

            },
            //  {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: "是否直发",
            //     fieldName: "isDirect",
            //     allowClear: true,
            //     showSearch: true,
            //     hidden: roles.includes('hd-supplier'),
            //     // options: getSelectedDictOne(DictCodeEnmu.DIRECT_TYPE),
            //     options: [{ label: "是", value: 1 }, { label: "否", value: 0 }],
            //     rules: [{ required: true, message: "请选择是否直发" }],
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                hidden: roles.includes('hd-supplier') && supMore,
                // colClassName:"iscm-ant-col-5"

            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "采购实体",
                options: beShopDs,
                allowClear: true,
                showSearch: true,
                fieldName: "bentityCode",
                hidden: roles.includes('hd-supplier'),
                onSelectChange: benttityChange,
                rules: [{ required: true, message: "请选择采购实体" }],
                // span: 5,
                // labelCol: { offset: 2 }, 
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购审批号",
                fieldName: "orderCode",
                disable: true,
                hidden: roles.includes('hd-supplier') && supMore,
            },
            // {
            //     type: FormItemTypeEnum.Button,
            //     fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
            //     fieldName: "none",
            //     span: 1,
            //     labelCol: { offset: 5 },
            // }, 

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "直发地址",
                fieldName: "detailedAddress",
                span: 8,
                hidden: more
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "收货单位",
                fieldName: "receivingUnit",
                hidden: more
                // colClassName:"iscm-ant-col-5"

            },

            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单人",
                fieldName: "createUser",
                disable: true,
                hidden: more
                // colClassName:"iscm-ant-col-5"
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单时间",
                fieldName: "createTime",
                disable: true,
                hidden: more
                // colClassName:"iscm-ant-col-5"
            },
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "到货日期",
            //     fieldName: "updateTime",
            //     disable: true,
            //     hidden: more
            // },
            //  {
            //     type: FormItemTypeEnum.Other,
            //     fieldLabel: '附件',
            //     fieldName: 'file',
            //     colClassName: 'ant-col-h-auto',
            //     span: 12,
            //     formItem: (
            //         <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
            //             <Upload
            //                 onPreview={onPreview}
            //                 name="file"
            //                 action={getBaseImgUploadUrl()}
            //                 data={getBaseUploadData()}
            //                 listType="picture"
            //                 beforeUpload={(file:any) => {
            //                     // let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
            //                     // // let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
            //                     // let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
            //                     // // var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
            //                     // let isType = filetypes?.includes(fileEnd)
            //                     // if (!isType) {
            //                     //     message.error('不支持该格式的上传,当前仅支持 图片、pdf和.doc 类型文件')
            //                     // }
            //                     const isLt20M = file.size / 1024 / 1024 < 20
            //                     if (!isLt20M) {
            //                         message.error('上传到文件不能超过20M')
            // file.status='done'
            //                     }
            //                     // return isType && isLt20M
            //                     return isLt20M
            //                 }}
            //                 iconRender={(file) => {
            //                     return (
            //                         <FontIcon
            //                             onClick={() => {
            //                                 onPreview(file)
            //                             }}
            //                             style={{ fontSize: '24px' }}
            //                             type="icon-tupian"
            //                         />
            //                     )

            //                 }}
            //             >
            //         {mode !== 'look' &&
            //             <>
            //                 <Button icon={<UploadOutlined />} >选择文件上传</Button>
            //                 </>}
            //             </Upload>
            //         </Form.Item>
            //     ),
            // },

            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商名称",
                fieldName: "supplierName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "供应商类型code",
                fieldName: "supplierTypeCode",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "商品类型名称",
                fieldName: "materialTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "采购类型名称",
                fieldName: "purchaseTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "运输方式名称",
                fieldName: "deliveryMethodName",
                hidden: true
            }

        ]
    };



    const onChange = (changedValues: { [key: string]: any }) => {
        let newChangedValues = changedValues;
        if ("supplierCode" in changedValues && changedValues.supplierCode) {
            let { name, typeCode, typeName, contact, phone } = getFindItem(changedValues.supplierCode as string, supplieAllList)
            newChangedValues = { ...changedValues, contact, phone, supplierName: name, supplierTypeCode: typeCode, supplierTypeName: typeName }
        }
        mode === "add" ? updateAddFormVal(newChangedValues) : updatEditFormVal(newChangedValues);
        setTopButsControl(true)
    }


    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        labelAlign: "right",
        disabled: mode === DetailType.look,
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }



    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        采购订单:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode]?.planCode ?? "暂无"}</span>
                        采购批次:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode]?.batchCode ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}